<div class="fx-row align-items-center justify-content-start" *ngIf="document">
  <div class="chip" [class.orange]="['PROCESSED','ERROR'].includes(document.status)"
    [class.light]="['PENDING','PROCESSING','DRAFT'].includes(document.status)">
    {{(['PROCESSED','ERROR'].includes(document.status) ? 'DOCUMENT.MISSING' : 'DOCUMENT.STATUS_PENDING') | translate}}
  </div>
</div>